<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="800px" scrollable :fullscreen="$vuetify.breakpoint.name == `xs`">
            <v-card :loading="loading" outlined>
                <v-card-title class="primary" dense>
                    <span class="headline text-uppercase white--text">{{ title }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container v-show="hasRole([`ADMIN`, `role-clientdetail:save`])">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field :value="get_product_name({ id: product_id })" label="Produto" readonly outlined></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                    <v-autocomplete
                                        v-model="role_id"
                                        :items="roles_product"
                                        :rules="[required]"
                                        item-text="name"
                                        item-value="id"
                                        label="Perfil"
                                        placeholder="Selecione o perfil"
                                        outlined
                                    ></v-autocomplete>
                                </v-form>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="add" :disabled="!hasRole([`ADMIN`, `role-clientdetail:save`])" depressed>
                                <v-icon left>mdi-plus-circle-outline</v-icon>ADICIONAR
                            </v-btn>
                        </v-row>
                        <v-divider></v-divider>
                    </v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                :headers="headers"
                                :items="items"
                                :loading="loading"
                            >
                                <template v-slot:item.product_name="{ item }">
                                    {{ get_product_name_role(item) }}
                                </template>
                                <template v-slot:item.role_id="{ item }">
                                    {{ get_role_name(item) }}
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn class="ma-2" icon :disabled="item.loading || !hasRole([`ADMIN`, `role-clientdetail:delete`])" v-on="on" @click="remove(item)">
                                                <v-icon color="error">mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <span style="color:#FFF">Remover</span>
                                    </v-tooltip>
                                </template>                
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="close" outlined>
                        <v-icon left>mdi-close-circle-outline</v-icon>FECHAR
                    </v-btn>
                    <v-btn color="primary" @click="save" :disabled="!hasRole([`ADMIN`, `role-clientdetail:save`])" >
                        <v-icon left>mdi-content-save-outline</v-icon>SALVAR
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>    
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'
    import { required } from '@/utils/roles.js'
    export default {
        data: () => ({
            loading: null,
            valid: null,
            lazy: false,
            role_id: null,
            headers: [
                { sortable: true, text: 'Produto', value: 'product_name', width: '47%' },
                { sortable: true, text: 'Perfil', value: 'role_id', width: '47%' },
                { sortable: false, text: 'Ações', value: 'actions', align: 'center', width: '6%' }
            ],
            items: []
        }),
        computed: {
            ...mapState('role', ['roles']),
            ...mapState('product', ['products']),
            ...mapGetters('product', ['get_product_name']),
            ...mapGetters('app', ['hasRole']),
            title() { return 'Perfis do Client ID: '+ this.client_id },
            dialog: {
                get() { return this.value },
                set(v) { this.$emit('input', v) }
            },
            roles_product() {
                var context = this
                var product_id = this.product_id
                if (product_id) {
                    var roles_filtred = []
                    
                    var roles = context.roles.filter(r => r.product_id == product_id)
                    roles.forEach(r => {
                        if (context.items.filter(i => i.role_id == r.id).length == 0) {
                            roles_filtred.push(r)
                        }
                    });

                    return roles_filtred
                }
                return []
            }
        },
        mounted() {
            this.search()
        },
        methods: {
            required,
            ...mapActions('product', { init_product: 'init_select' }),
            ...mapActions('role', { init_role: 'init_select' }),
            add() {
                if (this.$refs.form.validate()) {
                    this.items.push({ role_id: this.role_id, client_id: this.client_id })
                    this.$refs.form.reset()
                }
            },
            remove({ role_id }) {
                var index = false
                for (var i = 0; i < this.items.length; i++) {
                    if (index === false) {
                        if (this.items[i].role_id == role_id) {
                            index = i
                        }
                    }
                }
                this.items.splice(index, 1)
            },
            async save() {
                await this.axios.post(this.$store.state.url_api + '/client-details/' + this.client_id +'/roles', this.items)
                this.close()
            },
            async search() {
                this.loading = true
                try {
                    await Promise.all([this.init_product(), this.init_role()])
                    if (this.client_id) {
                        this.axios.get(this.$store.state.url_api + '/client-details/'+ this.client_id +'/roles')
                            .then(r => {
                                this.items = r.data
                                this.loading = false
                            })
                            .catch(() => {
                                this.loading = false
                            })
                    }
                }
                catch (_) {
                    this.loading = false
                }
            },
            get_role_name({ role_id }) {
                if (role_id) {
                    return this.roles.filter(r => r.id == role_id)[0].name
                }
                return 'Perfil não encontrado'
            },
            get_product_name_role({ role_id }) {
                var role = this.roles.filter(r => r.id == role_id)[0]
                if (role) {
                    var product = this.products.filter(p => p.id == role.product_id)[0]
                    if (product) {
                        return product.name
                    }
                }
                return 'Produto não encontrado'
            },
            close() {
                this.dialog = false
                this.$refs.form.reset()
            }
        },
        props: {
            value: Boolean,
            client_id: {
                type: String,
                required: true
            },
            product_id: {
                type: String,
                required: true
            }
        },
        watch: {
            client_id() {
                this.search()
            }
        }
    }
</script>